export const matchMedia =
  typeof window !== 'undefined' ? window.matchMedia : () => ({ matches: false })
